/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { FaTimes } from "react-icons/fa";
import { AiOutlineLoading } from "react-icons/ai";
import Service from "../../../../api/service";
import { Pagination } from "../../component/Pagination";
import { MyButton } from "../../component/ButtonUtils";
import { SiDatabricks } from "react-icons/si";
import { Data } from "./Data";
import { MdArrowBackIos } from "react-icons/md";

const NewsletterModal = ({
  loading,
  onSubmit,
  onClose,
  contentTitle,
  setContentTitle,
  dataIds,
  setDataIds,
}) => {
  const [data, setData] = useState(null);
  const [count, setCount] = useState(null);
  const [dataLoading, setDataLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [showMenu, setShowMenu] = useState(true);
  const [contentType, setContentType] = useState("");
  const [primaryKey, setPrimaryKey] = useState("");

  useEffect(() => {
    if (!data && contentType !== "") getData();
  }, [data, contentType, showMenu, contentTitle, dataIds]);

  const getData = async (currentPage, currentPageSize) => {
    setDataLoading(true);
    const response = await Service.get(
      `/api/v1${contentType}/?page=${currentPage || page}&pageSize=${currentPageSize || pageSize}&send_notification=0`
    );
    setDataLoading(false);
    if (response?.data?.data) {
      setData(response?.data?.data);
      setCount(response?.data?.count);
    }
  };

  const addToList = (content_id) => {
    if (!dataIds.includes(content_id)) setDataIds([...dataIds, content_id]);
  };

  const removeFromList = (content_id) => {
    setDataIds(dataIds?.filter((id) => id !== content_id));
  };

  const modal = (
    <div
      className="fixed inset-0 z-[2147483647] flex items-start justify-center overflow-y-auto bg-black/60 px-4 py-6 backdrop-blur-sm"
      role="dialog"
      aria-modal="true"
      data-portal
    >
      <div className="pointer-events-auto w-full max-w-3xl overflow-hidden rounded-2xl bg-white/95 shadow-2xl ring-1 ring-gray-200">
        <div className="sticky top-0 z-10 flex items-center justify-between border-b bg-white/90 px-4 py-3 backdrop-blur supports-[backdrop-filter]:bg-white/70">
          <div className="flex items-center gap-2">
            {!showMenu ? (
              <button
                onClick={() => {
                  setContentType("");
                  setContentTitle("");
                  setPrimaryKey("");
                  setData(null);
                  setShowMenu(true);
                  setDataIds([]);
                }}
                className="inline-flex items-center gap-1 rounded-lg border border-gray-200 bg-white px-3 py-2 text-xs font-medium text-gray-700 shadow-sm transition hover:bg-gray-50"
              >
                <MdArrowBackIos className="text-xs" />
                Back
              </button>
            ) : null}
            <span className="truncate text-sm font-semibold text-gray-900">
              {contentTitle !== "" ? contentTitle : "Select Newsletter Content"}
            </span>
          </div>

          <div className="flex items-center gap-2">
            <span className="hidden sm:inline-flex items-center gap-2 rounded-full bg-gray-50 px-2.5 py-1 text-[11px] font-medium text-gray-700 ring-1 ring-gray-200">
              Selected: <span className="font-semibold">{dataIds?.length || 0}</span>
            </span>
            <button
              onClick={onClose}
              className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-gray-900 text-white transition hover:bg-gray-800"
            >
              <FaTimes className="text-sm" />
            </button>
          </div>
        </div>

        <div className="max-h-[75vh] overflow-y-auto p-4">
          {showMenu ? (
            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
              {Data?.map((item, key) => (
                <div
                  key={key}
                  onClick={() => {
                    setShowMenu(false);
                    setContentType(item.link);
                    setContentTitle(item.name);
                    setPrimaryKey(item.primary_key);
                    setData(null);
                  }}
                  className="group cursor-pointer rounded-xl border border-gray-200 bg-white p-3 shadow-sm transition hover:-translate-y-0.5 hover:bg-gray-50 hover:shadow-md"
                >
                  <div className="flex items-start gap-2">
                    <div className="grid h-8 w-8 place-items-center rounded-lg bg-gray-900 text-white shadow">
                      <SiDatabricks className="text-sm" />
                    </div>
                    <div className="min-w-0">
                      <p className="truncate text-xs font-semibold text-gray-900">
                        {item?.name}
                      </p>
                      <p className="mt-0.5 text-[11px] text-gray-500">
                        Pick items to include
                      </p>
                    </div>
                  </div>
                  <div className="mt-3">
                    <MyButton
                      title="Manage"
                      className="w-full rounded-lg bg-gray-900 py-2 text-xs font-semibold text-white transition hover:bg-gray-700"
                    />
                  </div>
                </div>
              ))}
            </div>
          ) : null}

          {!showMenu ? (
            <>
              <div className="rounded-xl border border-gray-200 bg-white shadow-sm">
                <div className="w-full overflow-x-auto">
                  <table className="min-w-full table-auto text-left text-sm">
                    <thead>
                      <tr className="bg-gray-50">
                        <th className="w-1/3 border-b border-gray-200 px-4 py-3 font-semibold text-gray-700">
                          Image
                        </th>
                        <th className="w-1/3 border-b border-gray-200 px-4 py-3 font-semibold text-gray-700">
                          Title
                        </th>
                        <th className="w-1/3 border-b border-gray-200 px-4 py-3 text-center font-semibold text-gray-700">
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100">
                      {data ? (
                        data?.map((content, key) => (
                          <tr key={key} className="align-top transition-colors hover:bg-gray-50">
                            <td className="px-4 py-3">
                              <div className="flex items-center justify-start">
                                <img
                                  src={content?.thumbnail}
                                  alt=""
                                  className="h-14 w-20 rounded-md object-cover ring-1 ring-gray-200"
                                />
                              </div>
                            </td>
                            <td className="px-4 py-3">
                              <div className="max-w-[50ch] break-words text-gray-900">
                                {content?.title || content?.name || content?.category}
                              </div>
                            </td>
                            <td className="px-4 py-3">
                              <div className="flex justify-end">
                                {!dataIds?.includes(content[primaryKey]) ? (
                                  <MyButton
                                    onClick={() => addToList(content[primaryKey])}
                                    className="rounded-lg bg-gray-900 px-3 py-2 text-xs font-semibold text-white transition hover:bg-gray-700"
                                  >
                                    Select
                                  </MyButton>
                                ) : (
                                  <MyButton
                                    onClick={() => removeFromList(content[primaryKey])}
                                    className="rounded-lg bg-red-600 px-3 py-2 text-xs font-semibold text-white transition hover:bg-red-700"
                                  >
                                    Remove
                                  </MyButton>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td className="px-4 py-6">
                            <div className="h-4 w-28 rounded bg-gray-200" />
                          </td>
                          <td className="px-4 py-6">
                            <div className="h-4 w-48 rounded bg-gray-200" />
                          </td>
                          <td className="px-4 py-6">
                            <div className="ml-auto h-8 w-20 rounded bg-gray-200" />
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {dataLoading ? (
                  <div className="flex w-full items-center justify-center py-4">
                    <AiOutlineLoading className="animate-spin text-xl text-gray-700" />
                  </div>
                ) : null}
              </div>

              <div className="mt-4">
                <Pagination
                  page={page}
                  setPage={setPage}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  total_items={count}
                  callbackFunction={(page, size) => {
                    setData([]);
                    getData(page, size);
                  }}
                />
              </div>
            </>
          ) : null}
        </div>

        {!showMenu ? (
          <div className="sticky bottom-0 border-t bg-white/90 px-4 py-3 backdrop-blur supports-[backdrop-filter]:bg-white/70">
            <button
              onClick={onSubmit}
              className="flex w-full items-center justify-center rounded-lg bg-gray-900 px-3 py-3 text-xs font-semibold text-white transition hover:bg-gray-800 disabled:cursor-not-allowed"
            >
              {loading ? (
                <AiOutlineLoading className="animate-spin text-base text-white" />
              ) : (
                <span>Send Newsletter</span>
              )}
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );

  return createPortal(modal, document.body);
};

export default NewsletterModal;
